<template>
    <div>
        <v-container class="mt-5">
            <v-row >
                <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                     <v-text-field
                        :value = student.stud_no
                        outlined
                        hint="Student No."
                        persistent-hint
                        dense    
                        readonly
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" xs="12" md="4" lg="4" xl="4">
                    <v-text-field
                        hint="Last Name"
                        persistent-hint
                        :value = student.lastname
                        outlined
                        dense
                        readonly
                        >
                    </v-text-field>
                </v-col>
                <v-col cols="12" sm="12" xs="12" md="4" lg="4" xl="4">
                    <v-text-field
                        hint="First Name"
                        persistent-hint
                        :value = student.firstname
                        outlined
                        dense
                        readonly
                        >
                    </v-text-field>
                </v-col>
                <v-col cols="12" sm="12" xs="12" md="4" lg="4" xl="4">
                    <v-text-field
                        hint="Middle Name"
                        persistent-hint
                        :value = student.midname
                        outlined
                        dense
                        readonly
                        >
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" xs="12" md="3" lg="3" xl="3">
                    <v-text-field
                        hint="Gender"
                        persistent-hint
                        :value= "student.gender == 'M' ? 'Male' : 'Female'"
                        outlined
                        dense
                        readonly
                        >
                    </v-text-field>
                </v-col>
                <v-col cols="12" sm="12" xs="12" md="3" lg="3" xl="3">
                    <v-text-field
                        hint="Birth Date"
                        persistent-hint
                        :value= student.birthdate
                        outlined
                        dense
                        readonly
                        >
                    </v-text-field>
                </v-col>
                <v-col cols="12" sm="12" xs="12" md="3" lg="3" xl="3">
                    <v-text-field
                        hint="Birth Place"
                        persistent-hint
                        :value= student.birth_place
                        outlined
                        dense
                        readonly
                        >
                    </v-text-field>
                </v-col>
                <v-col cols="12" sm="12" xs="12" md="3" lg="3" xl="3">
                    <v-text-field
                        hint="Civil Status"
                        persistent-hint
                        :value= "civstat(student.civ_stat)"
                        outlined
                        dense
                        readonly
                        >
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
                    <v-text-field 
                        hint="Address"
                        persistent-hint
                        :value = student.home_addr_street
                        outlined
                        dense
                        readonly
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import moment from 'moment'
export default {
    name: 'StudentProfile',
    props: ['student'],
    data: () => ({
        firstname: '',
        lastname: '',
        midname: '',
        gender: '',
    }), 
    methods: {
        civstat(val) {
           switch (val) {
                case 'S':
                    return 'SINGLE'
                    break;
                case 'M': 
                    return 'MARRIED'
                    break;
                case 'D': 
                    return 'DIVORCED'
                    break;
                case 'P':
                    return 'SEPARATED'
                    break;
                case 'W':
                    return 'WIDOWED'
                    break;    
                default:
                    return ''
                   break;
           }
    
        }
    }
}
</script>
<style scoped>
input[type="date"]::-webkit-inner-spin-button,
input[type="date"]::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
}
</style>